import { render, staticRenderFns } from "./bread_crumbs.vue?vue&type=template&id=befa2c4c&scoped=true"
import script from "./bread_crumbs.vue?vue&type=script&lang=js"
export * from "./bread_crumbs.vue?vue&type=script&lang=js"
import style0 from "./bread_crumbs.vue?vue&type=style&index=0&id=befa2c4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "befa2c4c",
  null
  
)

export default component.exports